import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { PublicComponent } from './public/public.component';
import { SecureComponent } from './secure/secure.component';
import { AuthGuard } from 'security/auth-guard';
import { SECURE_ROUTES } from './secure/secureRoutes';
import { PUBLIC_ROUTES } from './public/publicRoutes';
import { LoginLogsComponent } from './public/login-logs/login-logs.component';
import { ContactUsComponent } from './public/contactus/contactus.component';
import { LiveAttendanceScreenComponent } from './live-attendance/live-attendance-screen.component';

export const routes: Routes = [
    {
        path: '',
        component: PublicComponent,
        data: { title: 'Public Views' },
        children: PUBLIC_ROUTES
    },
    // Standalone full-screen window (no sidebar/topbar); reuses the same auth session.
    {
        path: 'live-attendance',
        component: LiveAttendanceScreenComponent,
        canActivate: [AuthGuard],
        data: { title: 'Live Attendance' }
    },
    {
        path: '',
        component: SecureComponent,
        canActivate: [AuthGuard],
        data: { title: 'Secure Views' },
        children: SECURE_ROUTES
    },
    { path: '**', redirectTo: 'login' },
    { path: 'login-logs', component: LoginLogsComponent },
    { path: 'contactUs', component: ContactUsComponent }
];

export const AppRoutes: ModuleWithProviders<any> = RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' });
